import React from 'react';
import { isNil } from 'ramda';

import TransactionPresenter from '../../../../../../presenters/TransactionPresenter';
import UserPresenter from '../../../../../../presenters/UserPresenter';
import SourceDataPresenter from '../../../../../../presenters/Transaction/SourceDataPresenter';
import CashbackPresenter from '../../../../../../presenters/CashbackPresenter';
import BankAccountPresenter from '../../../../../../presenters/BankAccountPresenter';
import appRoutes from '../../../../../../routes/appRoutes';
import Group from '../../../../../../components/Group';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import Value from '../../../../../../components/Value';

const TransactionInfo = (props) => {
  const { transaction, cashback } = props;
  const user = TransactionPresenter.user(transaction);
  const sourceData = TransactionPresenter.sourceData(transaction);
  const auth0Id = UserPresenter.auth0Id(user);
  const linkToFastCash = appRoutes.userFastCashPath({ byAuth0Id: auth0Id });
  const refundGroupId = TransactionPresenter.refundGroupId(transaction);
  const bankAccount = TransactionPresenter.bankAccount(transaction);

  return (
    <div>
      <Group>
        <Row>
          <Value attr="email" title="User email">
            {UserPresenter.email(user)}
          </Value>
          <Value attr="auth0Id" title="User auth0 id">
            <a href={linkToFastCash}>{auth0Id}</a>
          </Value>
        </Row>
      </Group>
      <Group title="General">
        <Row>
          <Column>
            <Value attr="name" title="Transaction name">
              {TransactionPresenter.name(transaction)}
            </Value>

            <Value attr="merchantName" title="Merchant name">
              {TransactionPresenter.merchantName(transaction)}
            </Value>
            <Value attr="storeName" title="Store name">
              {TransactionPresenter.storeName(transaction) || '--'}
            </Value>
            <Value attr="location" title="Location">
              {JSON.stringify(TransactionPresenter.location(transaction))}
            </Value>
          </Column>
          <Column>
            <Value attr="amount" title="Amount">
              {TransactionPresenter.amountReadable(transaction)}
            </Value>
            <Value attr="status" title="Status">
              {TransactionPresenter.status(transaction)}
            </Value>
            <Value attr="state" title="State">
              {TransactionPresenter.state(transaction)}
            </Value>
            <Value attr="cashbackRate" title="Cashback Rate">
              {isNil(cashback) && <span>--</span>}
              {!isNil(cashback) && (
                <a
                  href={appRoutes.cashbackPath(CashbackPresenter.id(cashback))}
                  target="_blank"
                >
                  {CashbackPresenter.rateReadable(cashback)}
                </a>
              )}
            </Value>
          </Column>
          <Column>
            <Value attr="paymentChannel" title="Payment channel">
              {TransactionPresenter.paymentChannel(transaction)}
            </Value>
            <Value attr="date" title="Transaction date">
              {TransactionPresenter.date(transaction)}
            </Value>
            <Value
              attr="duplicationState"
              title="Bank Account Duplication State"
            >
              {BankAccountPresenter.duplicationStateReadable(bankAccount)}
            </Value>
          </Column>
        </Row>
      </Group>
      <Group title="Source Info">
        <Row>
          <Column>
            <Value attr="sourceTransactionId" title="Source Transaction id">
              {SourceDataPresenter.sourceTransactionId(sourceData)}
            </Value>
            <Value attr="bankdAccountId" title="Source Bank Account Id">
              {SourceDataPresenter.sourceAccountId(sourceData)}
            </Value>
          </Column>
        </Row>
      </Group>
      <Group title="Refund Info">
        <Row>
          <Column>
            <Value attr="refundGroupId" title="Refund Group">
              {isNil(refundGroupId) && <span>--</span>}
              {!isNil(refundGroupId) && (
                <a
                  href={appRoutes.transactionsDashboardPath({
                    byRefundGroupId: refundGroupId,
                  })}
                  target="_blank"
                >
                  {refundGroupId}
                </a>
              )}
            </Value>
          </Column>
          {TransactionPresenter.isRefund(transaction) && (
            <Column>
              <Value attr="refundStatus" title="Refund Status">
                {TransactionPresenter.refundStatusReadable(transaction)}
              </Value>
            </Column>
          )}
        </Row>
      </Group>
    </div>
  );
};

export default TransactionInfo;
